export default __webpack_public_path__ + "static/media/america_icon.c3ccff29.png";